import { CostCode, CrewMember, TimeEntryInput, Scalars, TimesheetCostCode } from '@bechtel/types';

export interface TimesheetDetailProps {
  showDateHeader: boolean;
  forDate: Date;
  setForDate: React.Dispatch<React.SetStateAction<Date>>;
}

export interface TSCostCode {
  costCode: CostCode;
  hourCodeTimeEntry: TimesheetByHourCode[];
  pinnedCostCodeId: TimesheetCostCode['id'];
}

export interface TimesheetByHourCode {
  hourCode: Scalars['String'];
  timeEntries: TimeEntryInput[];
  allowEdit: boolean;
}

export interface TimesheetFormikState {
  timesheetCostCodes: TSCostCode[];
}

export interface TimesheetCrewSummary {
  crewEmployee: CrewMember;
  timeEntries: TimeEntryInput[];
}

export enum TimesheetReasons {
  TIMESHEET_REASON_OTHER = 'TIMESHEET_REASON_OTHER',
}
